import { render, staticRenderFns } from "./LiteracyComponent2.vue?vue&type=template&id=7888b7f8&scoped=true&"
import script from "./LiteracyComponent2.vue?vue&type=script&lang=js&"
export * from "./LiteracyComponent2.vue?vue&type=script&lang=js&"
import style0 from "./LiteracyComponent2.vue?vue&type=style&index=0&id=7888b7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888b7f8",
  null
  
)

export default component.exports